import Vue from 'vue'
import SecureVHtml from 'directives/secure-v-html'

Vue.directive('secure-v-html', SecureVHtml)
